/*
 * Quiet "recently sold" note.
 *
 * The entries are REAL recent orders — city + product actually purchased,
 * city-level only (no names, no addresses). They are NOT hard-coded here:
 * theme.liquid renders the shop metafield `onhow.recent_sales` into
 * window.__onhowRecentSales, so refreshing that one metafield updates the
 * note everywhere without touching theme code.
 *
 * Strategy (deliberately tuned against feeling like a FOMO popup):
 * - Appears at a RANDOMIZED moment (10s–2min after load), never a fixed
 *   timer, so it can't be pattern-matched as "the software's clock".
 * - Never shows a visitor their own purchase — see OWN_ITEMS_KEY below.
 * - Each entry is marked as permanently seen (localStorage, survives across
 *   sessions/tabs) once shown to a given browser, so the same sale is never
 *   shown twice to the same visitor.
 * - At most once per hour per visitor.
 * - Always reads "kürzlich" rather than a precise counter, since the feed is
 *   a periodic snapshot rather than a live stream.
 */
(function () {
  var FIRST_DELAY_MIN_MS = 10000;
  var FIRST_DELAY_MAX_MS = 120000;
  var VISIBLE_MS = 7000;
  var COOLDOWN_MS = 60 * 60 * 1000;
  var LAST_SHOWN_AT_KEY = 'onhowRecentSaleLastShownAt';
  var SEEN_KEY = 'onhowRecentSaleSeenIds';
  var OWN_ITEMS_KEY = 'onhowOwnItems';
  var RECENCY_LABEL = 'kürzlich';

  var COLLECTION_RULES = [
    [/jeans|denim/i, 'vintage-denim-jeans'],
    [/trainingshose|jogginghose|trainingsanzug/i, 'trainingshosen'],
    [/polo|trikot|t-shirt|shirt/i, 'vintage-polos-shirts'],
    [/pullover|sweater|sweatshirt|strick/i, 'pullover-sweater'],
    [/jacke|mantel|weste|parka/i, 'vintage-jacken-mantel'],
    [/sonnenbrille|portmonee|geldbörse|gürtel|tasche|schal|mütze|cap/i, 'vintage-accessoires-1'],
  ];

  if (window.top !== window.self) return; // don't run inside theme-editor/app iframes
  if (/^\/(cart|checkout)/.test(window.location.pathname)) return;

  var SALES = Array.isArray(window.__onhowRecentSales) ? window.__onhowRecentSales : [];

  function categorize(product) {
    for (var i = 0; i < COLLECTION_RULES.length; i++) {
      if (COLLECTION_RULES[i][0].test(product)) return COLLECTION_RULES[i][1];
    }
    return 'alle-artikel';
  }

  // Compares a feed product against a cart product: the feed strips the size
  // marker, carts keep it, and casing/quoting differ — so both sides are
  // reduced to the same shape before matching.
  function normalise(title) {
    return String(title || '')
      .toLowerCase()
      .replace(/\s*\([^)]*\)\s*$/, '')
      .replace(/[„“”"']/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function readList(key) {
    try {
      var raw = JSON.parse(localStorage.getItem(key));
      return Array.isArray(raw) ? raw : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(key, list) {
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
  }

  // "Own purchase" detection without any checkout-side script: every item this
  // browser has ever held in its cart is remembered. Because each piece here
  // is one of a kind, a product title is effectively a unique identifier — so
  // anything the visitor had in their cart that later shows up as sold is
  // almost certainly their own order, and gets filtered out. Runs on every
  // page load, which covers the whole window between adding to cart and
  // checking out (Shopify empties the cart once the order is placed).
  function rememberOwnCartItems() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var own = readList(OWN_ITEMS_KEY);
        var changed = false;
        cart.items.forEach(function (item) {
          var key = normalise(item.product_title || item.title);
          if (key && own.indexOf(key) === -1) { own.push(key); changed = true; }
        });
        if (changed) writeList(OWN_ITEMS_KEY, own.slice(-80));
      })
      .catch(function () {});
  }

  function saleId(sale) {
    return sale.c + '|' + sale.p;
  }

  function markSeen(id) {
    var seen = readList(SEEN_KEY);
    seen.push(id);
    writeList(SEEN_KEY, seen.slice(-200));
    try { localStorage.setItem(LAST_SHOWN_AT_KEY, String(Date.now())); } catch (e) {}
  }

  function cooldownActive() {
    try {
      var last = parseInt(localStorage.getItem(LAST_SHOWN_AT_KEY) || '0', 10);
      return Date.now() - last < COOLDOWN_MS;
    } catch (e) {
      return false;
    }
  }

  function pickEntry() {
    var seen = readList(SEEN_KEY);
    var own = readList(OWN_ITEMS_KEY);
    var candidates = SALES.filter(function (sale) {
      if (!sale || !sale.c || !sale.p) return false;
      if (seen.indexOf(saleId(sale)) !== -1) return false;
      if (own.indexOf(normalise(sale.p)) !== -1) return false; // the visitor's own order
      return true;
    });
    if (!candidates.length) return null;
    return candidates[Math.floor(Math.random() * candidates.length)];
  }

  function stickyCartOffset() {
    var bar = document.querySelector('sticky-add-to-cart.sticky-add-to-cart--visible');
    if (bar && bar.offsetHeight) return bar.offsetHeight + 16;
    return 16;
  }

  function klaviyoOverlayVisible() {
    var nodes = document.querySelectorAll('[class*="klaviyo"],[id*="klaviyo"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var rect = el.getBoundingClientRect();
      if (rect.width > 300 && rect.height > 300) {
        var style = getComputedStyle(el);
        if ((style.position === 'fixed' || style.position === 'absolute') && style.visibility !== 'hidden' && style.display !== 'none') {
          return true;
        }
      }
    }
    return false;
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function buildToast() {
    var el = document.createElement('a');
    el.className = 'onhow-recent-sale';
    el.innerHTML =
      '<span class="onhow-recent-sale__body">' +
        '<span class="onhow-recent-sale__text"></span>' +
        '<span class="onhow-recent-sale__meta"></span>' +
      '</span>' +
      '<button type="button" class="onhow-recent-sale__close" aria-label="Schließen">' +
        '<svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5L5 19"/></svg>' +
      '</button>';
    document.body.appendChild(el);
    return el;
  }

  function attemptShow() {
    if (cooldownActive()) return;
    if (klaviyoOverlayVisible()) {
      window.setTimeout(attemptShow, 3000);
      return;
    }

    var sale = pickEntry();
    if (!sale) return;
    markSeen(saleId(sale));

    var toastEl = buildToast();
    toastEl.href = '/collections/' + categorize(sale.p);
    toastEl.style.bottom = stickyCartOffset() + 'px';
    toastEl.querySelector('.onhow-recent-sale__text').innerHTML =
      'Verkauft nach <strong>' + escapeHtml(sale.c) + '</strong> · ' + RECENCY_LABEL;
    toastEl.querySelector('.onhow-recent-sale__meta').textContent = sale.p;

    requestAnimationFrame(function () {
      toastEl.classList.add('is-visible');
    });

    var hideTimer = window.setTimeout(hide, VISIBLE_MS);

    function hide() {
      window.clearTimeout(hideTimer);
      toastEl.classList.remove('is-visible');
    }

    toastEl.querySelector('.onhow-recent-sale__close').onclick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      hide();
    };
  }

  // Cart tracking runs even when there is nothing to show, so the exclusion
  // list is already populated by the time a visitor's own order appears.
  rememberOwnCartItems();

  if (!SALES.length) return;
  var randomDelay = FIRST_DELAY_MIN_MS + Math.random() * (FIRST_DELAY_MAX_MS - FIRST_DELAY_MIN_MS);
  window.setTimeout(attemptShow, randomDelay);
})();
